/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/17/20
 * Time: 12:35 PM
 */
import React, {Component} from 'react';
import './CourseSlides.scss';
import Slider from "react-slick";
import {Button, Card, CardBody, Col, Row} from "reactstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as constants from "../../const/constants";
// import * as commonFunc from "../../utils/commonFunc";
import {withRouter} from "react-router";
import * as actionCreator from "../../store/domain/classes/action";
import {connect} from "react-redux";
import moment from "moment";
// import MonthSelector from "../MonthPicker/MonthSelector";
import * as actionSpinnerCreator from "../../store/domain/spinner/action";
import * as actionModalCreator from "../../store/domain/modal/action";
// import * as commonFunc from "../../utils/commonFunc";
// // import {MDBContainer, MDBScrollbar} from "mdbreact";
import i from "react-icofont";
import {lang, language} from "../../const/language";
import * as commonFunc from "../../utils/commonFunc";
import {getSliderSetting} from "../../utils/commonFunc";
import NotFound from "../NotFound/NotFound";
import * as classService from "../../services/class";
import swal from "sweetalert";
import {setPaymentModal_} from "../../store/domain/modal/action";

class App extends Component {
    state = {
        selectMonth: -1, selectClassId: 0
    };
    purchaseHandler = (id, classId) => {
        // this.setState({selectMonth: id, selectClassId: classId})
        this.props.setPaymentModal(true, {classId: classId})
    };

    viewLectureHandler = async (object) => {

        if (object.buttonStatus === constants.BUY_TEXT && object.fee === 0){
            if(this.props.userType !== 1){
                swal({
                    title: constants.GUEST_STUDENT_FOR_FREE,
                    icon: null,
                    closeOnClickOutside: false,
                    buttons: {
                        cancel: language[lang].NotNowText,
                        dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                    },
                }).then((value) => {
                    switch (value) {
                        case "action":
                            // props.history.push(`${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`);
                            window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                            break;
                        default:
                            break;
                    }
                });
            } else {
                this.props.spinnerHandler({isSpin: true, type: 15});
                const data = {
                    classId: object.id,
                    studentId: this.props.userObj.id,
                    year: moment().format('YYYY'),
                    month: moment().format('MMMM').toUpperCase()
                }
                await classService.joinFreeClass(data)
                    .then(response => {
                        this.props.spinnerHandler(false);
                        if (response.success) {
                            this.props.history.push({
                                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
                                state: `${object.id}`
                            })
                        }else{
                            commonFunc.notifyMessage(response.message, response.status);
                        }
                    })
            }
        } else {
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_CLASS_ROUTE}`,
                state: `${object.id}`
            })
        }

    };
    viewClassLessons = (object) => {
        commonFunc.viewClassResources(this.props, object.id)
    };
    joinClassHandler = (object) => {
        commonFunc.joinClassHandler(this.props, object)
    };
    render() {
        let {classesByLecture, lecturer, privileges} = this.props;
        let firstWeek = new Date().getDate() <= 12;
        let settings = getSliderSetting(classesByLecture);

        return (

            <div>
                <div className={"slide-show"}>
                    <Slider {...settings}>
                        {
                            classesByLecture.map((element, index) => {
                                return <div key={index}>
                                    <div
                                        className={`slideshow-wrapper shadow border-0 card ${element.buttonStatus === constants.BOUGHT_TEXT && `purchased`}`}>
                                        <div className={"display-inline slideshow-user-wrapper"}>
                                            <img src={element.imageUrl} alt={"."}
                                                 className={"blur-img"}
                                                 onClick={() => this.viewLectureHandler(element)}/>
                                            <img src={element.imageUrl} alt={"."}
                                                 className={"slideshow-pro-image shadow"}
                                                 onClick={() => this.viewLectureHandler(element)}/>
                                            <h2 className={"view-icon"}><i className="icofont-listing-box"
                                                                           onClick={() => this.viewLectureHandler(element)}/>
                                            </h2>
                                            <div className={"slideshow-middle"}>
                                                <div className={"cursor"}>
                                                    <div onClick={() => this.viewLectureHandler(element)}>
                                                        <h4 className={"topic"}>{element.name}</h4>
                                                    </div>

                                                    <div onClick={() => this.viewLectureHandler(element)}>
                                                        <Row className={"card-row"}>
                                                            <Col xs="6"><p className={"name"}>{lecturer.name}</p></Col>
                                                            <Col xs="6">
                                                                {element.fee === 0 ?
                                                                    <p className={"amount"}>{language[lang].FreeCard}</p> :
                                                                    <p className={"amount"}>{`Rs.${parseFloat(element.fee ? element.fee : 0).toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}/= ${language[lang].PerMonth}`}</p>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    {
                                                        element.dayTimes.length !== 0 ?
                                                        <Card className={"card-control"}
                                                              onClick={() => this.viewLectureHandler(element)}>
                                                            <CardBody>
                                                                <p className={"card-title"}>{language[lang].ClassSchedule}</p>
                                                                {
                                                                    element.dayTimes !== 0 && element.dayTimes.map((dayTime, i) => (
                                                                        <p className={"day"}>
                                                                            <li key={i}> {`${language[lang][dayTime.day]}:  ${moment(`2000-01-01 ${dayTime.startTime}`).format('h:mm a')} to ${moment(`2000-01-01 ${dayTime.endTime}`).format('h:mm a')}`}</li>
                                                                        </p>

                                                                    ))
                                                                }
                                                                {
                                                                    (element.nextDayOfClass !== undefined && element.nextDayOfClass !== null) &&
                                                                    <p className={"next0"}><span className={"next2"}><i
                                                                        className="icofont-calendar mr-1"/>{language[lang].NextClassIsOn}</span>
                                                                        <span
                                                                            className={"next1"}>{` ${moment(element.nextDayOfClass.replace("Z", "")).format("YYYY MMM DD ")}`} </span>
                                                                    </p>
                                                                }


                                                            </CardBody>
                                                        </Card> : null
                                                            // <Card className={"card-control"}
                                                            //       onClick={() => this.viewLectureHandler(element)}>
                                                            //     <CardBody>
                                                            //         <p className={"card-title"}>{language[lang].ClassSchedule}</p>
                                                            //         <p className={"day"}>
                                                            //             <p>-</p>
                                                            //         </p>
                                                            //         <p className={"day"}>
                                                            //             <p>-</p>
                                                            //         </p>
                                                            //     </CardBody>
                                                            // </Card>
                                                    }

                                                    {
                                                        element.fee === 0 ?
                                                            <div className={"btn-ctrl"}>
                                                                <Button
                                                                    className={"reg-btn com-btn bold-text red-btn custom-size-full"}
                                                                    onClick={() => this.viewLectureHandler(element)}>
                                                                    {language[lang].FreeForThisMonth}
                                                                </Button>
                                                            </div>
                                                            :
                                                            <div className={"btn-ctrl"}>
                                                                {
                                                                    element.buttonStatus === constants.BUY_TEXT ?
                                                                        <Button
                                                                            className="log-btn com-btn bold-text none-margin"
                                                                            onClick={() => this.purchaseHandler(index, element.id)}>
                                                                            {language[lang].PurchaseTheMonthPass}
                                                                        </Button> : null
                                                                }
                                                                {
                                                                    (lecturer.privileges.split(':')[0] === '1' &&
                                                                        (element.firstWeekFree && firstWeek) &&
                                                                        element.buttonStatus === constants.BUY_TEXT) ?
                                                                        <Button className="com-btn log-btn bold-text mt-3" color="default"
                                                                                onClick={()=>this.joinClassHandler(element)} >
                                                                            {language[lang].JoinTheClass}
                                                                        </Button> : null
                                                                }
                                                                {
                                                                    element.buttonStatus === constants.PENDING_TEXT ?
                                                                        <Button
                                                                            className="pending-btn com-btn bold-text "
                                                                            onClick={() => this.viewLectureHandler(element)}>
                                                                            {language[lang].PaymentPending}
                                                                        </Button> : null
                                                                }
                                                                {
                                                                    element.buttonStatus === constants.BOUGHT_TEXT ?
                                                                        <Button className={"reg-btn com-btn bold-text "}
                                                                                onClick={() => this.viewLectureHandler(element)}>
                                                                            {language[lang].PaidForThisMonth}
                                                                        </Button> : null
                                                                }
                                                                {
                                                                    element.buttonStatus !== constants.BOUGHT_TEXT &&
                                                                    <Button className={"log-btn com-btn bold-text mt-3"}
                                                                            onClick={() => this.viewLectureHandler(element)}>
                                                                        {language[lang].ViewClassText}
                                                                    </Button>
                                                                }
                                                                {
                                                                    (lecturer.privileges.split(':')[0] === '1' &&
                                                                        element.buttonStatus === constants.BOUGHT_TEXT) &&
                                                                    <Button className="com-btn log-btn bold-text mt-3" color="default"
                                                                            onClick={()=>this.joinClassHandler(element)} >
                                                                        {language[lang].JoinTheClass}
                                                                    </Button>
                                                                }
                                                                {/*{*/}
                                                                {/*    (privileges === '1' && element.buttonStatus === constants.BOUGHT_TEXT) ?*/}
                                                                {/*        <Button*/}
                                                                {/*            className={"log-btn com-btn bold-text mt-3"}*/}
                                                                {/*            onClick={() => this.viewClassLessons(element)}>*/}
                                                                {/*            {language[lang].ClassResources2}*/}
                                                                {/*        </Button> : null*/}
                                                                {/*}*/}

                                                                {
                                                                    privileges === '1' &&
                                                                        <Button
                                                                            className={"log-btn com-btn bold-text mt-3"}
                                                                            onClick={() => this.viewClassLessons(element)}>
                                                                            {language[lang].ClassResources2}
                                                                        </Button>
                                                                }

                                                            </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </Slider>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    lecturer: state.lecturer.lecturer,
    userObj: state.student.userObj
});

const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
